import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllTalentAgenciesQuery } from '@anytag/graphql';

export const useAllTalentAgencyOptions = (options?: QueryHookOptions<Query>) => {
  const { data, loading } = useAllTalentAgenciesQuery({
    fetchPolicy: 'cache-and-network',
    ...options
  });

  return {
    loading,
    allTalentAgencyOptions: getSelectOptions(data?.allTalentAgencies)
  };
};
